<template>
  <v-dialog v-model="displayForm" persistent max-width="980px">
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-card>
        <v-card-title>
          <span class="headline" v-if="item">Update Shipping</span>
          <span class="headline" v-else>Add Shipping</span>
        </v-card-title>
        <div class="text-xs-center">
          <v-progress-circular indeterminate color="primary" v-if="loading"></v-progress-circular>
        </div>
        <v-card-text v-if="!loading">
          <v-alert
            :value="message"
            type="error"
            dismissible
            transition="scale-transition"
          >{{ message }}</v-alert>
          <v-row>
            <v-col>
              <v-text-field v-model="model.name" label="Name" :rules="mandatoryRules"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field v-model="model.price" label="Price" :rules="mandatoryRules" type="number"></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn outlined @click="cancel()" :disabled="loading">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            v-if="item"
            color="accent"
            outlined
            @click="update()"
            :disabled="loading"
          >Update</v-btn>
          <v-btn v-else color="accent" outlined @click="add()" :disabled="loading">Add</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
function getDefaultData() {
  return {
    model: {
      id: null,
      name: null,
      price: null,
      locationId: null
    },
    mandatoryRules: [v => !!v || "This fiels is mandatory"],
    message: null,
    valid: null
  };
}
export default {
  props: ["item", "value", "id"],
  data: getDefaultData,
  computed: {
    displayForm: {
      set(value) {
        this.$emit("input", value);
      },
      get() {
        return this.value;
      }
    },
    loading: function() {
      return this.$store.getters["shippings/loading"];
    }
  },
  watch: {
    item: function(newVal) {
      // watch it
      Object.assign(this.model, newVal);
    }
  },
  methods: {
    add() {
      if (this.$refs.form.validate()) {
        this.model.locationId = this.id;
        this.$store
          .dispatch("shippings/add", {
            model: this.model
          })
          .then(({shipping}) => {
              this.$emit("add", shipping);
              this.resetForm();
              this.displayForm = false;
              this.flashMessage.success({
                message: "Shipping added",
              });
          })
          .catch((res) => {
            this.flashMessage.error({
              message: res.message,
            });
          })
      }
    },
    update() {
      if (this.$refs.form.validate()) {
        this.model.locationId = this.id;
        this.$store
          .dispatch("shippings/update", {
            model: this.model
          })
          .then(() => {
              this.$emit("update");
              this.resetForm();
              this.displayForm = false;
              this.flashMessage.success({
                message: "Shipping updated",
              });
          })
          .catch((res) => {
            this.flashMessage.error({
              message: res.message,
            });
          })
      }
    },
    cancel() {
      this.$emit("cancel");
      this.displayForm = false;
      this.resetForm();
    },
    resetForm() {
      Object.assign(this.$data, getDefaultData());
      this.$refs.form.reset();
    }
  }
};
</script>

<style></style>
